import { RegisterType } from './types'

export const accountsReturnToParam = 'accountsReturnTo'

export const registerTypes: RegisterType[] = [
  'patient',
  'practitioner',
  'private-label-practitioner',
  'private-label-unlicensed',
  'student',
  'patient-zip-code',
]
